import React, { FC, useEffect } from "react";
import map from "lodash/map";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Product } from "@/services/productService";
import PlpAnalytics from "@/services/analytics/main/plp";
import { useAppSelector } from "@/redux/store";
import { selectCdnImageSettings } from "@/util/selectors";
import ContentImage from "@/components/content/contentImage";
import { useRouteSlug } from "@/hooks";

import "./style.scss";

const RelatedProducts: FC<{
  product: Product;
}> = ({ product }) => {
  const { t } = useTranslation("productDetails");
  const cdnImageSettings = useAppSelector(selectCdnImageSettings);
  const routeSlug = useRouteSlug();

  const relatedItemsLength = product.relatedProducts?.length;

  useEffect(() => {
    if (relatedItemsLength) {
      PlpAnalytics.impressions({
        items: product.relatedProducts,
        listHeading: `${relatedItemsLength} ${
          relatedItemsLength === 1 ? t("similarProduct") : t("similarProducts")
        }`
      });
    }
  }, [relatedItemsLength]);

  if (!relatedItemsLength) return null;
  return (
    <div className="related_product_items">
      <p>
        {relatedItemsLength}
        <span>
          {relatedItemsLength === 1
            ? t("similarProduct")
            : t("similarProducts")}
        </span>
      </p>
      {map(product.relatedProducts, relatedItem => (
        <div className="product_item" key={relatedItem.id}>
          <Link
            to={{
              pathname: `/${routeSlug}/${relatedItem.url}`,
              state: { isAvailableColorItem: true }
            }}
          >
            <ContentImage
              url={cdnImageSettings?.thumb}
              img={relatedItem.captionImageURL}
              lazyLoad={true}
            />
          </Link>
        </div>
      ))}
    </div>
  );
};

export default RelatedProducts;
